import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { orderBy } from 'lodash';

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrl: './multi-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiSelectComponent implements OnInit, OnDestroy {
  @Input() label: string = '';
  @Input() labelIcon: string = '';
  @Input() options: any[] = [];
  @Input() labelKey: string = 'value';
  @Input() valueKey: string = 'uuid';
  @Input() boxSize: string = '200';
  @Input() class!: string;
  @Input() iconStyle!: string;
  @Input() hideBadge: boolean = false;
  @Input() badgePosition: 'left' | 'right' = 'right';
  @Input() dropdownPosition: 'left' | 'right' = 'left';
  @Input() disabledSorting: boolean = false;
  @Input() disabledSearchBox: boolean = false;
  @Input() singleSelection: boolean = false;
  @Input() commaDelimited: boolean = false;
  @Input() selectAllSetting: boolean = false;
  @Input() showLabelOnTop: boolean = false;
  @Input() labelActive: boolean = false;
  @Input() placeholderMessage: string = '';
  @Output() onSelect = new EventEmitter<any[] | any>();
  @Input() maxVisibleSelections: number = 2;
  @Input() hideSelectedText: boolean = false;
  @Input() compactDisplay: boolean = false; // When true, shows only first selection + count
  // @Input() selectedValues: any[] = [];
  @Input() set selectedValues(values: any[]) {
    if (!values || values.length === 0) {
      // debugger;
      this.selected = [];
      this.updateSelectedLabelValue();
    } else {
      this.selected = this.options.filter(option =>
        values.some(selectedValue => selectedValue[this.valueKey] === option[this.valueKey])
      );
      this.updateSelectedLabelValue();
    }
    this.cdr.detectChanges();
  }

  @ContentChild('extraContent', { static: false })
  extraContentTemplate!: TemplateRef<any>;

  timeoutId: any;
  delay = 500;
  selected: any[] = [];
  filteredOptions: any[] = [];
  searchTerm: string = '';
  showDropdown: boolean = false;
  foundCount: number | null = 0;
  selectedLabelValue = '';



  ngOnInit() {

    // try {
    //   this.selected = this.options.filter(option =>
    //     this.selectedValues.some(selectedValue => selectedValue[this.valueKey] === option[this.valueKey])
    //   );
    // } catch (error) {
    //   console.log(error);
    //   debugger;
    // }


    // this.updateSelectedLabelValue();
    // this.onSelect.emit(this.selected);
  }
  constructor(private eRef: ElementRef, private cdr: ChangeDetectorRef) {
    this.filteredOptions = [...this.options];
  }
  onMouseLeave() {
    this.timeoutId = setTimeout(() => {
      this.showDropdown = false;
    }, this.delay);
  }

  onMouseEnter() {
    clearTimeout(this.timeoutId);
  }

  ngOnDestroy(): void {
    clearTimeout(this.timeoutId);
  }

  ngOnChanges() {
    this.filterOptions();
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }
  clearSelection() {
    this.selected = [];
    this.searchTerm = '';
    this.filterOptions();
  }

  filterOptions() {
    const searchTermLower = this.searchTerm.toLowerCase();

    const filtered = this.options.filter((option) => {
      const value = option[this.labelKey];
      const valueAsString = value == null ? '' : value.toString().toLowerCase();
      return valueAsString.includes(searchTermLower);
    });

    if (!this.disabledSorting) {
      this.filteredOptions = orderBy(filtered, [this.labelKey.toLowerCase()], ['asc']);
    } else {
      this.filteredOptions = filtered;
    }
  }

  selectOption(option: any) {
    if (this.singleSelection) {
      this.selected = [option];
      this.selectedLabelValue = option[this.labelKey];
    } else {
      const index = this.selected.findIndex(
        (sel) => sel[this.valueKey] === option[this.valueKey],
      );
      if (index > -1) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(option);
      }
    }

    if (this.commaDelimited) {
      this.selectedLabelValue = this.selected.map(sel => sel[this.labelKey]).join(', ');
    }

    this.onSelect.emit(this.selected);
    this.cdr.detectChanges();
  }
  isSelected(option: any): boolean {
    return (
      this.selected.findIndex(
        (sel) => sel[this.valueKey] === option[this.valueKey],
      ) > -1
    );
  }
  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.showDropdown = false;
    }
  }


  selectAll() {
    this.selected = [...this.options];
    this.onSelect.emit(this.selected);
    this.updateSelectedLabelValue();
  }

  deselectAll() {
    this.selected = [];
    this.onSelect.emit(this.selected);
    this.updateSelectedLabelValue();
  }

  updateSelectedLabelValue() {
    this.selectedLabelValue = this.commaDelimited
      ? this.selected.map(sel => sel[this.labelKey]).join(', ')
      : '';
    this.cdr.detectChanges();
  }

  get selectedDisplayText(): string {
    if (this.compactDisplay) {

      if (this.selected.length === 0) {
        return '';
      } else if (this.selected.length === 1) {
        return this.selected[0][this.labelKey];
      } else {
        const firstSelection = this.selected[0][this.labelKey];
        const additionalCount = this.selected.length - 1;
        return `${firstSelection} +${additionalCount}`;
      }
    } else {
      if (this.selected.length <= this.maxVisibleSelections) {
        return this.selected.map(sel => sel[this.labelKey]).join(', ');
      } else {
        const visibleSelections = this.selected.slice(0, this.maxVisibleSelections);
        const remainingCount = this.selected.length - this.maxVisibleSelections;
        return `${visibleSelections.map(sel => sel[this.labelKey]).join(', ')} +${remainingCount}`;
      }
    }
  }
}
